/**
 * Vanilla entry point. Importing this module side-effect-registers the
 * <hw-chat> Web Component. Works in React/Vue/Svelte/Angular/Astro/plain
 * HTML — anywhere an HTML element can render.
 *
 * For the React-native experience with typed JSX props, import from
 * '@hostwebhook/chat-widget/react' instead.
 */
export { HwChatElement, registerHwChat } from './element/HwChat.js';
export type { HwChatOptions, AuthProvider, AuthToken, ChatConfig } from './core/types.js';
export type {
  VoiceProvider,
  VoiceTurn,
  VoiceMode,
  VoiceSessionHandle,
  StartVoiceSessionOptions,
} from './core/voice-driver.js';
